module.exports = __webpack_public_path__ + "static/media/screenshot-10.b3997612.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-10.png
// module id = 695
// module chunks = 2